// import { Box, Skeleton, useMediaQuery } from "@chakra-ui/react";
import { Box, useMediaQuery } from "@chakra-ui/react";
import ReactGA from "react-ga4";
import { Helmet } from "react-helmet";

import FilteredGames from "../Components/Games/FilteredGames";
import { useGames } from "../Hooks/useGetGames";
import Carousel from "../Components/Carousel/Carousel";
import GameBannerAd from "../Components/Advertisement/GameBannerAd";
import ComicPanel from "../Components/Comics/ComicPanel";
import taktLogo from "../assets/LBPortal_Graphic_AdBG.webp";
// import { motion } from "framer-motion";
// import { useEffect, useState } from "react";

function Homepage() {
  ReactGA.send({
    hitType: "pageview",
    page: "/",
    title: "Home",
  });
  const { data, isLoading } = useGames();

  // const [skeleton, setSkeleton] = useState(false);

  //try mobile
  const [isLargerThan1580] = useMediaQuery("(min-width: 1580px)")

  // useEffect(() => {
  //   setTimeout(() => {
  //     setSkeleton(true);
  //   }, 1000);
  // }, []);

  if (isLoading) return <div />;

  const carouselGames = data.games.filter(
    (game) => game.is_display_in_slideshow === true
  );

  const singlePlayer = data.games.filter(
    (item) => !item.description.includes("Multiplayer")
  );

  const multiPlayer = data.games.filter((item) =>
    item.description.includes("Multiplayer")
  );

  return (
    <>
      <Helmet>
        <title>Leaderbored</title>
        <link rel='canonical' href='https://www.leaderbored.gg' />
        <meta
          name='description'
          content='Page consisting of webcomics and free HTML5 games to play.'
        />
      </Helmet>

      
      <Box color='white'>
      {/* Hide Carousel, Comic, GOTW, etc */}
        <div style={{display: 'none'}}>
          <Carousel games={carouselGames} />
          <GameBannerAd />
          <Box id='comics'>
            <ComicPanel />
          </Box>

          <Box
            bgImage={taktLogo}
            bgPos='center'
            bgSize='cover'
            borderRadius='20px'
            mb='40px'
            bgRepeat='no-repeat'
          >
            <FilteredGames
              heading={"Game of the week"}
              games={[singlePlayer[0]]}
            />
          </Box>
        </div>

        <FilteredGames heading={"Single player"} games={singlePlayer} isPC={isLargerThan1580} />
        <GameBannerAd />
        <FilteredGames heading={"Multiplayer"} games={multiPlayer} isPC={isLargerThan1580} />
        <GameBannerAd />
      </Box>
    </>
  );
}

export default Homepage;
